function dataLayerEvents() {
  if (document.body.classList.contains("properties-template-properties")) {
    const button = document.querySelector(".property-page__request");

    if (button) {
      button.addEventListener("click", function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "clickRequestCall" });
        console.log("event pushed: clickRequestCall");
      });
    }
  }
}

module.exports = dataLayerEvents;
